import { GET_ACTIVE_CITIES_PENDING, GET_ACTIVE_CITIES_SUCCESS, GET_ACTIVE_CITIES_FAILURE } from './types';
import baseUrl from '../../url';

const fetchLocationRequest = () => {
    return {
        type: GET_ACTIVE_CITIES_PENDING
    }
}

const fetchLocationSuccess = location => {
    return {
        type: GET_ACTIVE_CITIES_SUCCESS,
        payload: location,
    }
}

const fetchLocationFailure = error => {
    return {
        type: GET_ACTIVE_CITIES_FAILURE,
        payload: error,
    }
}

export const getActiveCities = () => {
    return (dispatch) => {
        dispatch(fetchLocationRequest());
        fetch(`${baseUrl}/cities/active_cities`, {
                method: 'GET'
            })
            .then(response => response.json())
            .then((response) => {
                dispatch(fetchLocationSuccess(response));
            })
            .catch((error) => {
                dispatch(fetchLocationFailure(error.message));
            })
    }
}